import { useEffect, useMemo } from 'react'
import cn from 'clsx'

import * as store from '@store'
import DocumentRow from './DocumentRow'
import useSortableTableHeaders from '@/hook/useSortableTableHeaders'
import { useSearchParams } from 'react-router-dom'
import { useWireValue } from '@forminator/react-wire'
import Th from '@/components/shared/TableHeaderManager/Th'

// TODO: apply recording date and comments
const headers = [
    ['name', 'Name', true, '90px'],
    ['grantors', 'Grantor', false, '200px'],
    ['grantees', 'Grantee', false, '200px'],
    ['bookVolume', 'Book Volume', true, '90px'],
    ['bookPage', 'Book Page', true, '90px'],
    ['bookType', 'Book Type', true, '90px'],
    ['instrumentNumber', 'Instr. #', true, '90px'],
    ['instrumentType', 'Instr. Type', true, '90px'],
    ['instrumentDate', 'Instr. Date', true, '140px'],
    ['fileDate', 'File Date', true, '140px'],
    ['allLegalDescriptions', 'Legal Description', false, '250px'],
]

const DocumentSearchResultsTable = ({
    className,
    top = '44px',
    documents,
    markedDocuments,
    setMarkedDocuments,
}) => {
    
    // @todo hack for now bc initial docs have rows, but search results don't
    const items = useMemo(() => documents?.rows ?? documents, [documents])
    
    const [searchParams, setSearchParams] = useSearchParams()
    const documentHeaders = useWireValue(store.documentHeaders)
    const { onHeaderClick, orderDirection, orderField } = useSortableTableHeaders(
        headers, 
        searchParams.get('field') || 'instrumentDate', 
        searchParams.get('order') || 'DESC',
    )
    const sortedHeaders = useMemo(() => (
        documentHeaders.length ? documentHeaders.map(dh => headers.find(h => h[0] === dh)) : headers
    ).filter(Boolean), [documentHeaders])
    
    useEffect(() => {
        setSearchParams(prev => {
            prev.set('field', orderField)
            prev.set('order', orderDirection)
            return prev
        })
    }, [orderDirection, orderField])
    
    return (
        
        <table className={cn(
            'DocumentSearchResultsTable',
            'table table-auto table-pin-rows card-table w-full',
            className,
        )}>
            
            <thead>
                <tr className={cn(`top-[${top}]`)}>
                    <th style={{ width: '56px', maxWidth: '56px' }}>
                        <input
                            type="checkbox"
                            className="checkbox-tract"
                            checked={
                                markedDocuments.length !== 0 &&
                                markedDocuments.length === documents?.length
                            }
                            onChange={e => setMarkedDocuments(e.target.checked
                                ? (documents?.map(d => d.id) || [])
                                : [])
                            } />
                    </th>
                    <th style={{ width: '115px', maxWidth: '115px' }}>Viewer</th>
                    {sortedHeaders.map(([slug, label, sortable, width]) =>
                        <Th
                            style={{ maxWidth: width, width }}
                            key={slug}
                            slug={slug}
                            label={label}
                            sortable={sortable}
                            onHeaderClick={onHeaderClick}
                            orderField={orderField}
                            orderDirection={orderDirection} />)}
                </tr>
            </thead>
            
            <tbody className="list-collection">
                {items?.map((doc, i) => (
                    <DocumentRow
                        doc={doc}
                        key={i}
                        markedDocuments={markedDocuments}
                        setMarkedDocuments={setMarkedDocuments} />
                ))}
            </tbody>
        </table>
        
    )
    
}

export default DocumentSearchResultsTable
